import { Dispatch, SetStateAction, useState } from "react";

import {
  API_KEY_FIELD_NAMES,
  ApiKeyErrors,
  ApiKeyObjectState
} from "@/Pages/Integrations/types";
import { API_KEY_INPUT_LENGTH } from "@/shared";

export const useApiCredentialValidation = (
  initialApiKeyObject: ApiKeyObjectState,
  setHasUpdatedEnable: Dispatch<SetStateAction<boolean>>
) => {
  const initialErrors: ApiKeyErrors = {
    [API_KEY_FIELD_NAMES.Name]: ""
  };

  const [errors, setErrors] = useState<ApiKeyErrors>(initialErrors);
  const [apiKeyObject, setApiKeyObject] =
    useState<ApiKeyObjectState>(initialApiKeyObject);

  const trimmedName = apiKeyObject[API_KEY_FIELD_NAMES.Name].trim();

  const nameValid =
    trimmedName.length > 0 && trimmedName.length <= API_KEY_INPUT_LENGTH.Name;

  const hasErrors = Object.values(errors).some(error => error !== "");

  const isReadyToConfirm =
    !hasErrors && nameValid && Boolean(apiKeyObject.selectedCompany);

  const resetAllValues = () => {
    setApiKeyObject(initialApiKeyObject);
    setHasUpdatedEnable(false);
    setErrors(initialErrors);
  };

  return {
    errors,
    setErrors,
    apiKeyObject,
    setApiKeyObject,
    isReadyToConfirm,
    resetAllValues
  };
};
